import {
    GraphQlClient,
 } from '@intelipost-js/secure-providers';
import {
    ScToast,
} from '@intelipost-js/secure-components';

export default {
  getWarehouses({ commit }) {
    commit('setLoading', true);

    return GraphQlClient.query(`
    query {
      warehousesDriver {
        id
        official_name
        code
        federal_tax_payer_id
        address {
          zip_code
        }
      }
    }`)
      .then((res) => {
        const { data = {} } = res || {};
        const { warehousesDriver = [] } = data || {};
        commit('setLoading', false);
        commit('setWarehouses', warehousesDriver);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('setLoading', false);
        return Promise.reject(err);
      });
  },
  createDriver({ commit, state }) {
    commit('setLoading', true);
    return GraphQlClient.mutation(`
    mutation (
        $first_name: String!
        $last_name: String!
        $email: String!
        $license: String!
        $license_plate: String!
        $cell_phone: String!
        $federal_tax_id: String!
        $warehouse_ids: [Int]!
    ) {
      createDriver (
        first_name: $first_name 
        last_name: $last_name
        email: $email
        license: $license
        license_plate: $license_plate
        cell_phone: $cell_phone 
        federal_tax_id: $federal_tax_id
        warehouse_ids: $warehouse_ids
      ) {
        ok
      }
    }`, state.accessDriver)
      .then(({ data }) => {
        const { createDriver } = data || {};
        const { ok } = createDriver;
        commit('setLoading', false);
        ScToast.success(ok);
        return Promise.resolve(data);
      })
      .catch((err) => {
        commit('setLoading', false);
        return Promise.reject(err);
      });
  },
  getAccessDrivers({ commit }) {
    commit('setLoading', true);
    return GraphQlClient.query(`
    query{
      getAccessDrivers{
        first_name
        last_name
        email
        federal_tax_id
      }
    }`)
    .then(({ data }) => {
      const { getAccessDrivers } = data || {};
      commit('setLoading', false);
      return Promise.resolve(getAccessDrivers || []);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },
  removeAccessDriver({ commit, dispatch }, accessDriver) {
    commit('setLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $federal_tax_id: String!
      $email: String
    ) {
      removeAccessDriver (
        federal_tax_id: $federal_tax_id
        email: $email
      ) {
        ok
      }
    }`, accessDriver)
      .then(({ data }) => {
        const { removeAccessDriver } = data || {};
        const { ok } = removeAccessDriver;
        commit('setLoading', false);
        ScToast.success(ok);
        return Promise.resolve(data);
      })
      .catch((err) => {
        commit('setLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-driver/store/actions.js